import { render, staticRenderFns } from "./EditFaqCategoryComponent.vue?vue&type=template&id=cb42027c&"
import script from "./EditFaqCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./EditFaqCategoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports